export enum DynamicFieldConditionLineOperator {
Equals,
NotEquals,
HasValue,
}
